<template>
  <div id="version-mobile">
    <div class="title-container">
      <h2>Guides et Liens</h2>
    </div>

    <div class="content-body">
      <h3 id="officiel">
        Officiel
      </h3>

      <ul>
        <li>
          <a
            href="https://honkaiimpact3.hoyoverse.com/global/fr-fr/home"
            target="_blank"
            rel="noopener"
          >Le site officiel pour l'Europe et les US.</a>
          <br>
          Les liens de téléchargement sont directement sur l'accueil.
        </li>
        <li>
          <a
            href="https://www.hoyolab.com/circles/1/32/feed?page_type=32&page_sort=hot"
            target="_blank"
            rel="noopener"
          >Forum officiel, avec guides et walkthrough.</a>
          <br>
          Annonces, guides et discussions. Disponible en français avec possibilité d'afficher les posts anglais en plus.<br>
          <small>
            <em>(Précédemment forums.mihoyo.com et walkthrough.honkaiimpact3.com)</em>
          </small>
        </li>
        <li>
          <a
            href="https://discord.gg/hi3"
            target="_blank"
            rel="noopener"
          >Le Discord officiel.</a>
          <br>
          Venez dans la catégorie francophone et n'hésitez pas à poser vos questions dans #aide-et-conseils !
        </li>
      </ul>

      <h3 id="en-français">
        En français
      </h3>

      <ul>
        <li>
          <a
            href="https://www.youtube.com/channel/UCZqGegfM36EvTOOA7E_DMOw/videos"
            target="_blank"
            rel="noopener"
          >Honkai pour les nuls</a>
          <br>
          Chaîne YouTube avec des tutoriels pour débuter.
        </li>
        <li>
          <a
            href="https://docs.google.com/document/d/1FNc-ugpD2wUcYAMhIdwc2lpv_pDKStGMJYChEhooBxI/edit"
            target="_blank"
            rel="noopener"
          >Le guide du débutant de Selephim.</a>
          <br>
          Très recommandé et en français ! Contient des liens vers d'autres guides pratiques et les guides de personnages à la fin (jusqu'à la 4.5).
        </li>
        <li>
          <a
            href="https://docs.google.com/document/d/1-rrZJ31nmDDEjnHyYptME2DABDhssYmMZtC4XqNYvkY"
            target="_blank"
            rel="noopener"
          >Guide: Marque de Prime par Yd.</a>
          <br>
          Ou en anglais "Bounty Mark".
        </li>
        <li>
          <a
            href="https://docs.google.com/document/d/1azLtF8IRnLahK97ltakSs_V1cnfJp13YSnaxjX03Su0/edit"
            target="_blank"
            rel="noopener"
          >Les guides de NJ.</a>
          <br>
          Guide avancé en français, diverses parties ne sont plus à jour depuis la 3.1 (mai 2020).
        </li>
      </ul>

      <h3 id="en-anglais">
        En anglais
      </h3>

      <ul>
        <li>
          <a
            href="https://honkai-guide.web.app/"
            target="_blank"
            rel="noopener"
          >Honkai Helper</a>
          <br>
          Outil pour chercher des vidéos contre les boss et calculatrice de votre composition.
        </li>
        <li>
          <a
            href="https://www.youtube.com/@MarisaHonkai/playlists?view=50&sort=dd&shelf_id=7"
            target="_blank"
            rel="noopener"
          >Marisa Honkai</a>
          <br>
          Playlists YouTube avec des infos et guides. La chaîne publie aussi du contenu venant des bêtas dans d'autres playlists.
        </li>
        <li>
          <a
            href="https://docs.google.com/spreadsheets/d/e/2PACX-1vSZN8GdNvB4Uc2Ieci34pExAmH5gDcJWgJf0VlXSjm_cHdQ5PucYoqc-L3lnj3kVasBjoPXv9yX5jBd/pubhtml#"
            target="_blank"
            rel="noopener"
          >Références pour le Memorial Arena.</a>
          <br>
          Liste de chaînes de joueurs avancés, liste des boss par version et recommendations de composition.
        </li>
        <li>
          <a
            href="https://honkaiimpact3.fandom.com/wiki/Augment_Core"
            target="_blank"
            rel="noopener"
          >Wiki: Augment Core</a>
          <br>
          Liste des Augment Cores et les ressources nécessaires pour rank up.
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
const title = 'Guides et Liens'
const description = 'Une petite liste de guides et de liens pratiques pour Honkai Impact 3rd.'
useSeoMeta({
  title: title,
  ogTitle: title,
  description: description,
  ogDescription: description,
})
</script>
